//#region ../base/util/environment.ts
function getEnvVariable(variable) {
	if (typeof window !== "undefined") {
		let envVar;
		try {
			envVar = import.meta.env[variable];
		} catch {}
		return envVar;
	}
	if (typeof process !== "undefined" && "versions" in process && typeof process.versions === "object" && "node" in process.versions && typeof process.versions.node === "string") return process.env[variable];
	throw new Error("Unsupported environment");
}
function getDomain() {
	if (typeof window === "undefined") return;
	return window.location.hostname.includes("jwplayer.com") ? "jwplayer.com" : void 0;
}

//#endregion
export { getDomain, getEnvVariable };